class ProductAddons extends HTMLElement {
  constructor() {
    super();

    this.formId = this.dataset.productFormId;
    this.form = document.querySelector(`form[id="${this.formId}"]`);
    this.addons = this.querySelectorAll('input.product-addon-item__checkbox');
    this.subtotalContainer = this.querySelector('.product-addons__subtotal');
    this.productPrice = this.dataset.productPrice;
    this.productCompareAtPrice = this.dataset.productCompareAtPrice;
    this.mainProductVariantId = this.dataset.productVariantId;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    // Cleanup all observers
    [this.intersectionObserver, this.buttonStateObserver].forEach(observer => {
      observer?.disconnect();
    });

    // Remove event listeners
    document.removeEventListener('variant:changed', this.handleVariantChange);
  }

  init() {
    this.setupAddonChangeListener();
    this.setupVariantChangeListener();
    this.addons.forEach(addon => {
      this.handleAddonChange(addon);
    });
  }

  reset() {
    this.addons.forEach(addon => {
      this.removeAddonFromForm(addon.dataset.addonId);
      addon.checked = false;
    });
    this.updateSubtotal();
  }

  setupVariantChangeListener() {
    document.addEventListener('variant:changed', this.handleVariantChange.bind(this));
  }

  setupAddonChangeListener() {
    this.addons.forEach(addon => {
      addon.addEventListener('change', () => this.handleAddonChange(addon));
    });
  }

  handleVariantChange(event) {
    const targetVariant = event.target.currentVariant;

    this.productPrice = this.dataset.productPrice = targetVariant.price;
    this.productCompareAtPrice = this.dataset.productCompareAtPrice = targetVariant.compare_at_price;
    this.mainProductVariantId = this.dataset.productVariantId = targetVariant.id;

    targetVariant.available ? this.setAvailable() : this.setUnavailable();
    this.reset();
  }

  setUnavailable() {
    this.setAttribute('disabled', 'disabled');
    this.addons.forEach(addon => addon.setAttribute('disabled', 'disabled'));
  }

  setAvailable() {
    this.removeAttribute('disabled');
    this.addons.forEach(addon => {
      if (addon.dataset.addonAvailable === 'true') {
        addon.removeAttribute('disabled');
      }
    });
  }

  handleAddonChange(addon) {
    const addonId = addon.dataset.addonId;
    const quantity = 1;

    addon.checked ? this.addAddonToForm(addonId, quantity) : this.removeAddonFromForm(addonId);
    this.updateSubtotal();
  }

  createHiddenInput(name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    return input;
  }

  addAddonToForm(addonId, quantity) {
    if (this.form.querySelector(`input[name="items[][id]"][value="${addonId}"]`)) return;

    const container = document.createElement('div');
    container.classList.add('addon-inputs');
    container.dataset.addonId = addonId;

    container.appendChild(this.createHiddenInput('items[][id]', addonId));
    container.appendChild(this.createHiddenInput('items[][quantity]', quantity));
    container.appendChild(this.createHiddenInput('items[][properties][_parent_id]', this.mainProductVariantId));

    this.form.appendChild(container);
  }

  removeAddonFromForm(addonId) {
    const container = this.form.querySelector(`.addon-inputs[data-addon-id="${addonId}"]`);
    container?.remove();
  }

  calculateTotals() {
    console.log("calculateTotals", this.productPrice, " - ", this.productCompareAtPrice);
    let totalPrice = parseFloat(this.productPrice);
    let totalCompareAtPrice = parseFloat(this.productCompareAtPrice) || totalPrice;
    let selectedAddons = [];

    this.addons.forEach(addon => {
      if (addon.checked && !addon.disabled) {
        const addonPrice = parseFloat(addon.dataset.addonPrice);
        const addonCompareAtPrice = parseFloat(addon.dataset.addonCompareAtPrice) || addonPrice;
        totalPrice += addonPrice;
        totalCompareAtPrice += addonCompareAtPrice;
        selectedAddons.push(addon);
      }
    });

    return { totalPrice, totalCompareAtPrice, selectedAddons };
  }

  updateSubtotal() {
    const { totalPrice, totalCompareAtPrice, selectedAddons } = this.calculateTotals();

    // Update subtotal display
    if (totalPrice > this.productPrice) {
      this.subtotalContainer.querySelector('.product-addons__subtotal-value').textContent = Shopify.renderPriceText(totalPrice);
      this.subtotalContainer.classList.remove('hidden');
    } else {
      this.subtotalContainer.querySelector('.product-addons__subtotal-value').textContent = Shopify.renderPriceText(this.productPrice);
      this.subtotalContainer.classList.add('hidden');
    }

    // Update price display
    const badgeText = totalCompareAtPrice > totalPrice ? 'SALE' : null;
    const discountText = totalCompareAtPrice > totalPrice ? `SAVE ${Shopify.renderPriceText(totalCompareAtPrice - totalPrice)}` : null;


    this.dispatchEvent(new CustomEvent('price:updated', {
      bubbles: true, detail: {
        variant_id: this.mainProductVariantId,
        compare_at_price: totalCompareAtPrice > totalPrice ? totalCompareAtPrice : null,
        price: totalPrice,
        badge: badgeText ? { type: 'sale', text: badgeText } : null,
        discount: discountText ? { type: 'discount', text: discountText } : null,
        reset: totalPrice == this.productPrice,
        addons: selectedAddons.length > 0 ? selectedAddons : null
      }
    }));

    if (typeof updateKlarnaPlacement === 'function') {
      updateKlarnaPlacement(totalPrice);
    }
  }
}

customElements.define('product-addons', ProductAddons);